import * as React from 'react';
import { evaluateCondition } from './conditionalRules';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultBlock = {
  blockRID: 'sharefile:view-unmounted/block-unmounted',
  blockName: '',
  blockParameters: {}
};
var defaultBlockContext = {
  view: {
    rid: 'sharefile:view-unmounted',
    name: '',
    rootBlockRID: 'sharefile:view-unmounted/block-unmounted',
    blocks: []
  },
  block: defaultBlock,
  piletApi: {},
  changeView: function changeView() {},
  completeInteraction: function completeInteraction() {},
  cancelInteraction: function cancelInteraction() {}
};
export var BlockContext = /*#__PURE__*/React.createContext(defaultBlockContext);
export var missingBlock = {
  blockRID: 'sharefile:view-missing/block-missing',
  blockName: '',
  blockParameters: {}
};
export function BlockContextProvider(_ref) {
  var children = _ref.children,
    blockRID = _ref.blockRID,
    piletApi = _ref.piletApi,
    view = _ref.view,
    allViews = _ref.allViews,
    changeView = _ref.changeView,
    completeInteraction = _ref.completeInteraction,
    cancelInteraction = _ref.cancelInteraction,
    paramSources = _ref.paramSources,
    contractSources = _ref.contractSources;
  var block = view.blocks.find(function (x) {
    return x.blockRID === blockRID;
  });
  if (!block) {
    block = missingBlock;
  }
  var contractSourcesWithFallback = contractSources !== null && contractSources !== void 0 ? contractSources : paramSources;
  if (block.condition && !evaluateCondition(contractSourcesWithFallback, block.condition)) {
    return null;
  }
  return /*#__PURE__*/_jsx(BlockContext.Provider, {
    value: {
      view: view,
      piletApi: piletApi,
      block: block,
      allViews: allViews,
      changeView: changeView,
      completeInteraction: completeInteraction,
      cancelInteraction: cancelInteraction,
      paramSources: contractSourcesWithFallback,
      contractDataSources: contractSourcesWithFallback
    },
    children: children
  });
}
export function useBlockContext() {
  return React.useContext(BlockContext);
}